import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import SearchFilter from './SearchFilter'
import Table from '../../../components/Common/Table'
import LafId from './LafId'
import CustomerName from './CustomerName'
import LeadStatus from "../TableItems/LeadStatus";
import LeadType from "../TableItems/LeadType";
import { Context } from '../../../config/store'
import LenderUgroService from '../../../services/lender'
import { toast } from 'react-toastify'
import './style.css'
import ReactTooltip from 'react-tooltip';
import Pagination from '../../../components/Pagination'
import objectToQueryParams from '../../../common/objectToQueryParams'
import TableNoRecords from '../../../components/Common/Table/TableNoRecords'

const TableCoulmns = [
  { title: 'LAF ID', field: 'laf_id', component: LafId },
	{ title: 'LAN ID', field: 'lan_id' },
	{ title: 'CLM Type', field: 'lead_assign_as_type', component: LeadType },
  { title: 'Customer Name', field: 'cust_name', component: CustomerName },
	{ title: 'Program Name', field: 'prod_name' },
  { title: 'Action', field: 'action' },
];

const View = ({ item }) => {
  const { state } = React.useContext(Context);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const StatusLog = []
  const [status, setStatus] = useState([])
  const [showTooltip, setShowTooltip] = React.useState(false)
  let sessionStorageData = JSON.parse(sessionStorage.getItem('searchData')) || {};
  const lenderId = sessionStorageData?.assignLender || ''

  React.useLayoutEffect(() => {
    setStatus(StatusLog)
  }, [item.id])

  const StatusCheck = async (ele) => {
    setLoading(true)
    let response = await LenderUgroService.getStatusApilogs({
      type: state.userType,
      cl_lead_id: ele.cl_lead_id,
      cl_lender_id: lenderId,
    });

    if (response?.status === 200) {
      setLoading(false)
      if (response?.data?.data?.log) {
        setStatus(response?.data?.data?.log?.ApplicationStatus)
        toast.success(response?.data?.data?.log?.Message)
      } else {
        setStatus([])
      }
    } else {
      toast("Some error occoured")
    }
  }
  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };
  return (
    <div className='row m-auto justify-content-around'>
      {checkHasPermission('view-collection-logs') && <>
        <button
          className='btn btn-custom viewBtn'
          onClick={(e) => {
            navigate(`/collection-logs/${item?.cl_lead_id}/${lenderId}/${item?.lead_type}`)
            e.preventDefault();
          }}
          data-tip
          data-for='view-logs'
        >
          <i className='fa fa-eye'></i>
        </button>
        <ReactTooltip id='view-logs'>View Logs</ReactTooltip>
      </>}
    </div>
  )
}

const CollectionsList = ({ path }) => {
  let sessionStorageData = JSON.parse(sessionStorage.getItem('searchData')) || {};
  let { org_page = 1 } = sessionStorageData;
  const queryString = objectToQueryParams(sessionStorageData);
  const [queryParams, setQueryParams] = React.useState(queryString);
  const [page, setCurrentPage] = useState(org_page);
  const [pagination, setPagination] = useState({});
  const [errors, setErrors] = useState({});
  const { state, dispatch } = useContext(Context);
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch({
      type: "selectedColender",
      selectedColender: path,
    });
    localStorage.setItem("selectedColender", path);
  }, [path]);

  useEffect(() => {
    if (!loading) {
      getCollectionsListing()
    }
  }, [queryParams])

  useEffect(() => {
    getCollectionsListing()
  }, [page])

  const getCollectionsListing = async (paramsChanged) => {
    try {
      const lenderId = sessionStorageData?.assignLender || ''
      let response = await LenderUgroService.getCollectionsList(
        {
          type: state.userType,
          page: paramsChanged ? 1 : page,
          dataExport: 0,
          queryParams: (queryParams && lenderId) ? queryParams+(lenderId == 1 ? '&lead_type=2' : '') : 'assignLender=-1'
        });
      if (response?.data?.status?.code == 1) {
        let resData = response?.data?.data?.cl_leads?.data
        if (lenderId != 15) {
          resData.map((item, i) => {
            resData[i].action = <View item={item}></View>;
          })
        }
        setCurrentPage(paramsChanged ? 1 : page);
        sessionStorage.setItem('searchData', JSON.stringify({ ...sessionStorageData, org_page: 1 }))
        setTableData(resData || [])
        setPagination(response?.data?.data.cl_leads.pagination);
      }
      setErrors({});
      setLoading(false)
    } catch (err) {
      let error = err?.response?.data?.messages?.error;
      toast.error(error?.form?.[0] || error?.others?.[0]);
      setErrors(error?.fields);
      setLoading(false);
    }
  }

  return (
    <div>
      <SearchFilter
        setQueryParams={setQueryParams}
        errors={errors}
      />
      <div className="d-flex justify-content-center mt-2">
        <div className={`collection_table ${Boolean(!tableData?.length)?'no_data': ''}`}>
          <Table
            checkbox={false}
            columns={TableCoulmns}
            rows={tableData}
            loading={loading}
            assignedLender={sessionStorageData.assignLender}
          >
            {Boolean(!tableData?.length && !loading) && <TableNoRecords />}
          </Table>
          <div className="my-2">
            {pagination?.total_pages ? (
              <Pagination
                disabled={loading}
                setPage={setCurrentPage}
                total_pages={pagination.total_pages}
                total={pagination.total}
                showTotal={true}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CollectionsList
